import React, {Fragment, useCallback, useEffect, useState} from "react";
import {useLocation} from "react-router";
import {Navbar, Overlay2 as Overlay, Spinner} from "@blueprintjs/core";
import styled from "styled-components";

import {ResourceNavigationHeader} from "/src/components/navigation";

import {DataPageContext} from "./context";


const HeaderMain = styled(Navbar)`
  width: 100%;
  margin-bottom: 1em;
  background-color: #19212F;
  color: rgba(255, 255, 255, 0.8);
`;

const OverlayContentStyle = styled.div`
    display: block;
    width: 100%;
    height: 100%;
    margin: auto;
    align-content: center;
    //textAlign: center;
`


const DataPageWrapper = ({children}) => {
    const location = useLocation();
    const [nav, setNav] = useState({});
    const [controls, setControls] = useState([]);
    const [navGroup, _setNavGroup] = useState([]);
    const [loading, _setLoading] = useState({status: false, location: "?"});
    const [count, setCount] = useState(null);
    const [prevPath, setPrevPath] = useState(location.pathname);

    // Reset all nav state when route changes — setState during render
    // runs BEFORE children mount/effects, so children's setNav/setControls
    // won't be wiped (unlike useEffect which fires parent AFTER children)
    if (prevPath !== location.pathname) {
        setPrevPath(location.pathname);
        setNav({});
        setControls([]);
        _setNavGroup([]);
        setCount(null);
    }

    useEffect(() => {
        console.log("Setting navigation context", loading);
    }, [loading]);

    const setNavGroup = useCallback((newNavGroup) => {
        _setNavGroup(newNavGroup);
        return newNavGroup;
    }, []);

    const setLoading = useCallback((newLoading) => {
        const ret = {
            status: newLoading.status ?? loading.status,
            location: newLoading.location ?? loading.location,
        };
        _setLoading(ret);
        return ret
    }, []);

    return <DataPageContext.Provider
        value={{
            nav: nav,
            setNav: setNav,
            controls: controls,
            setControls: setControls,
            navGroup: navGroup,
            setNavGroup: setNavGroup,
            loading: loading,
            setLoading: setLoading,
            setCount: setCount,
        }}
    >
        <Fragment>
            <Overlay
                isOpen={loading.status}
                canOutsideClickClose={false}
                canEscapeKeyClose={false}
            >
                <OverlayContentStyle>
                    <Spinner intent='primary' size={100}/>
                </OverlayContentStyle>
            </Overlay>
            <HeaderMain>
                <Navbar.Group align='left'>
                    <Navbar.Heading>
                        { count ? `(${count.filtered !== count.total ? `${count.filtered}/${count.total}` : count.total}) - ` : '' }{ loading.location }
                    </Navbar.Heading>
                </Navbar.Group>
            </HeaderMain>
            {nav.right?.length || nav.left?.length
                ? <ResourceNavigationHeader
                    left={nav.left?.length ? [...nav.left] : []}
                    right={nav.right?.length ? [...nav.right, ...navGroup, ...controls] : [...navGroup, ...controls]}
                />
                : null
            }
            {children}
        </Fragment>
    </DataPageContext.Provider>;
}

export {DataPageWrapper};
